import { render, staticRenderFns } from "./PrepareMedForm.vue?vue&type=template&id=084137f9&scoped=true"
import script from "./PrepareMedForm.vue?vue&type=script&lang=js"
export * from "./PrepareMedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084137f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('084137f9')) {
      api.createRecord('084137f9', component.options)
    } else {
      api.reload('084137f9', component.options)
    }
    module.hot.accept("./PrepareMedForm.vue?vue&type=template&id=084137f9&scoped=true", function () {
      api.rerender('084137f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/treatment/PrepareMedForm.vue"
export default component.exports